import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../../utils/Seo";

const TermsCondition = () => {
  return (
    <>
      <SEO
        title="Terms and Conditions - MyAd360"
        description="Understand the terms and conditions for using MyAd360's ad monetization services."
        keywords="MyAd360 terms, ad policy, user agreement, publisher rules"
      />

      <div className="paddingX py-9">
        <main className="relative overflow-hidden py-24">
          <div className="mx-auto container paddingX">
            <div className="tinymce-content">
              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                Terms of Use
              </h4>
              <p>
                Following are the terms and conditions that govern your use of
                this Site (“Terms of Use”).
              </p>
              <p>
                Using this site tells us that you have read and agreed to our
                Terms of Use detailed below and our{" "}
                <Link className="text-green-400"> Privacy Policy.</Link> Please
                read the following sections carefully. If you do not agree with
                these terms, please exit this Web Site or any site affiliated with
                this Web Site. These Terms of Use apply to all web sites owned and
                operated by myad360. myad360 reserves the right to terminate
                Membership (defined below) and deny access to the Site to any
                person who violates these Terms of Use.
              </p>

              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                Future Changes
              </h4>
              <p>
                myad360 may change these Terms of Use, including our{" "}
                <Link className="text-green-400"> Privacy Policy.</Link>, upon
                notice, which may be given by posting such notice on the Web Site.
                However, in some cases, if in the reasonable view of myad360, a
                change to the Terms of Use or to our{" "}
                <Link className="text-green-400"> Privacy Policy.</Link>{" "}
                constitutes a material change, such a change will not take effect
                until 14 days after notice is provided, during which time you may
                notify us that you do not accept the change. Your continued use of
                the Web Site after such 14 day period will mean that you accept
                any such change. Although we may choose to notify you of changes
                by email or by other means, you agree that notice of changes to
                the Terms of Use and{" "}
                <Link className="text-green-400"> Privacy Policy.</Link> posted on
                the Web Site constitutes reasonable and sufficient notice.
              </p>
              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                Intellectual Property Rights
              </h4>
              <p>
                All information, content, services and software displayed on,
                transmitted through or used in connection with myad360 sites,
                including, but not limited to, news articles, reviews,
                directories, guides, text, photographs, images, illustrations,
                audio clips, video, html, source and object code, trademarks,
                logos and the like, as well as its selection and arrangement
                (together, the “Content), is owned by myad360 and its affiliated
                companies or the third party credited as the owner of the Content.
                You may use the Content online only, and solely for your personal,
                non-commercial use. If you operate a web site and wish to link to
                any of the sites owned and operated by myad360, you may do so
                provided you agree to cease such link upon request from myad360
                and that you do not state or imply any sponsorship of your site by
                myad360 (for example, by using our stylized trademark or logo). No
                other use is permitted without prior written
              </p>
              <p className="mt-4">
                permission of myad360. The permitted use described in this
                Paragraph is contingent on your compliance at all times with these
                Terms of Use.
              </p>
              <p className="mt-4">
                You may not, for example, republish any portion of the Content on
                any internet, intranet or extranet site or incorporate the Content
                in any database, compilation, archive or cache. You may not
                distribute any Content to others, whether or not for payment or
                other consideration, and you may not modify, copy, frame, cache,
                reproduce, sell, publish, transmit, display or otherwise use any
                portion of the Content. You may not scrape or otherwise copy our
                Content without written permission. You agree not to decompile,
                reverse engineer or disassemble any software or other products or
                processes accessible through the Web Site, or insert any code or
                product or manipulate the Content of myad360 or the Web Site in
                any way that affects the user’s experience, and not to use any
                data mining, data gathering or extraction method.
              </p>
              <p className="mt-4">
                In certain cases, you may be able to obtain a license to use
                individual stories that appear on the Web Site or affiliated
                myad360 Web Sites through online functionality we have
                specifically designated. For example, email a story to a friend or
                purchase a photograph.
              </p>

              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                Copyright Complaints
              </h4>
              <p>
                myad360 respects the intellectual property of others and holds no
                claim to copyrights of Content that is owned by a third party or
                is in the public domain. If you believe your work has been copied
                in a way that constitutes copyright infringement or you are aware
                of any infringing material on any of myad360 Web Sites, please
                provide to myad360 Copyright and Intellectual Property Agent the
                following information at mailto:info@myad360.com:
              </p>
              <ul className="mt-4 list-disc">
                <li>
                  an electronic or physical signature of the person authorized to
                  act on behalf of the owner of the copyright or other
                  intellectual property interest;
                </li>
                <li>
                  a description of the copyrighted work or other intellectual
                  property interest that is the subject of your claim;
                </li>
                <li>
                  a description of where the material is located on the Web Site;
                </li>
                <li>your address, telephone number, and e-mail address;</li>
                <li>
                  a statement by you that you have a good faith belief that access
                  to the relevant material through the Site is inappropriate;
                </li>
                <li>
                  a statement by you, made under penalty of perjury, that the
                  above information in your notice is accurate and that you are
                  the copyright or other intellectual property owner or authorized
                  to act on the copyright or other intellectual property owner’s
                  behalf.
                </li>
              </ul>
              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                Membership, Registration, Termination and Passwords
              </h4>
              <p>
                To use certain features of certain services provided by myad360,
                you must register on the form(s) provided. Once registered you
                will become a “Member” and will be considered to have “Membership”
                in the Web Site. If you become a Member of the myad360 Web Site,
                or any of its affiliated Web Sites or services, you accept
                responsibility for all activities that occur under your account
                and password, and agree not to sell, transfer or assign your
                Membership or any Membership rights.
              </p>
              <p className="mt-4">
                When registering, you agree to provide true, accurate, current and
                complete information about yourself as prompted by the Web Site’s
                registration form and to maintain and promptly update the
                information you provide to keep it true, accurate, current and
                complete. We reserve the right to terminate your Membership at any
                time for any reason and without notice. In the event of
                termination, you are no longer authorized to access the part of
                the Web Site affected by such cancellation or termination. The
                restrictions imposed on you with respect to material downloaded
                from any portion of the Web Site, and the disclaimers and
                limitations of liabilities set forth in these Terms of Use, shall
                survive.
              </p>
              <p className="mt-4">
                You are responsible for maintaining the confidentiality of your
                password and for restricting access to your computer so others
                outside your household may not access myad360 using your name in
                whole or in part without your permission. If you believe someone
                has accessed your member name and/or password without your
                authorization, e-mail us immediately. myad360 cannot and will not
                be liable for any loss or damage arising from your failure to
                protect your password or account information.
              </p>
              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                License to myad360
              </h4>
              <p>
                By posting a message, uploading a file, providing information to,
                communicating with, or otherwise placing any material on our Web
                Sites, you are granting myad360, an irrevocable, royalty-free,
                perpetual, non-exclusive, unrestricted right and license to use,
                copy, sublicense, modify, display, archive, store, distribute,
                reproduce and create derivative works from such information, in
                any form, media, software or technology or any kind now existing
                or
              </p>
              <p className="mt-4">
                developed in the future. Without limiting the generality of the
                previous term, you authorize myad360 and its affiliates to share
                the information across all myad360 locations, other myad360 Web
                Sites and to use your name and any other information in connection
                with its use of the material you provide. All such rights are
                granted without the requirement for additional compensation of any
                sort to you and without further permission required.
              </p>
              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                Interactive Features
              </h4>
              <p>
                Services offered by myad360 or any of its affiliates on any of its
                Web Sites may include a variety of features, such as message
                boards, photo galleries, comments and other interactive features
                which will allow feedback to myad360 and real-time interaction
                between users (collectively “Services”). These features are
                provided to give users an interesting and stimulating forum to
                express their opinions and share ideas and information. myad360
                cannot and does not monitor all of the material posted or
                transmitted by users and third party information providers.
              </p>
              <p className="mt-4">
                It is a condition of your use of these Services that you generally
                exercise your best judgment and specifically do not:
              </p>
              <ul className="mt-4 list-disc">
                <li>
                  Restrict or inhibit any other user(s) from using and enjoying
                  the Web Site.
                </li>
                <li>
                  Post any material that contains vulgar, profane, abusive,
                  hateful or racist language or expressions, text, photographs or
                  illustrations in poor taste, or attacks of a personal, racial or
                  religious nature.
                </li>
                <li>
                  Post any material that is threatening, false, defamatory,
                  misleading, fraudulent, unfair, and inaccurate, contains gross
                  exaggeration or unsubstantiated claims, violates the privacy
                  rights of any party, is unreasonably harmful or offensive to any
                  individual, community, association, business or group.
                </li>
                <li>
                  Violate any right of myad360 or any of its subsidiaries or
                  affiliates.
                </li>
                <li>
                  Post any material that discriminates, or refers to such matters
                  in any manner prohibited by law.
                </li>
                <li>
                  Disrupt, interfere with or otherwise harms or violates the
                  security of myad360, the Web Site or any services, resources,
                  passwords, servers or networks through myad360 or affiliated or
                  linked sites.
                </li>
                <li>
                  Post any material that contains or links to viruses or other
                  harmful, disruptive or destructive files.
                </li>
                <li>
                  Use or attempt to use another’s identity, account, password,
                  service or system except as expressly permitted by the Terms of
                  Use.
                </li>
                <li>
                  Post any material that includes copyrighted or other proprietary
                  material of any kind without express permission of the owner of
                  the material.
                </li>
                <li>
                  Post any material that includes advertisements, promotions, or
                  offers to trade any goods or services, except in areas
                  specifically designated for such purpose, if available.
                </li>
                <li>
                  Post any material that violates or encourages the violation of
                  any municipal, state, federal or international law, rule or
                  regulation.
                </li>
              </ul>
              <p className="mt-4">
                myad360 reserves the right to delete any communications at any
                time, for any reason or in its discretion, but has no obligation
                to review or remove any such content. myad360 also reserves the
                right to disclose any information as necessary to satisfy any law,
                regulation or governmental request, or to refuse to post or to
                remove any information or materials, in whole or in part, that in
                myad360’s sole discretion are objectionable or in violation of
                these Terms of Use.
              </p>

              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                Responsibility for the Content You Submit
              </h4>
              <p>
                You are fully responsible for any content you submit on our Web
                Site (which includes posting a message, uploading a file,
                providing information to, communicating with, or otherwise placing
                any material on the Web Site). You also understand that we are not
                responsible for any content you may submit on the Web Site. You
                also understand and certify that you have the permission of others
                who may have contributed to or are featured or depicted in any
                content you submit on the Web Site. If there are any individuals
                under the age of 18 in any photographs, videos, or images in the
                content you intend to submit on the Web Site you must obtain and
                you certify that you have obtained the permission of the parent or
                legal guardian of any such individual before submitting such
                content.
              </p>

              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                E-Commerce and Transactions on our Web Sites
              </h4>
              <p>
                myad360 may allow you to engage in a transaction involving the
                purchase of a product or service such as a newspaper subscription,
                a print or online
              </p>
              <p className="mt-4">
                advertisement, a print of a photograph, a photograph product or
                other tangible goods and services. To serve you most efficiently,
                credit card transactions and order fulfillment are often handled
                by a third party. These third parties may have separate privacy
                and data collection practices, so please be sure to read these as
                well. If you’re concerned about online credit card safety, in most
                cases a telephone number will be provided so that you can call to
                place your order by phone. myad360 cannot take responsibility for
                the success or security of transactions undertaken or processed by
                third parties. myad360 is not responsible for the quality,
                accuracy, timeliness, reliability or any other aspect of these
                third-party products and services. You agree to release myad360,
                myad360 and its affiliates from any damages that you incur, and
                agree not to assert any claims against them, arising from your
                purchase or use of any products or services made available by
                third parties through myad360.
              </p>
              <h4 className="text-[24px] font-bold text-[#0d0c1b]">Links</h4>
              <p className="mt-4">
                Links to or from other Internet sites may be included at times as
                a convenience to the user. These sites have not necessarily been
                reviewed by myad360 and are maintained by third parties over which
                myad360 exercises no control. Accordingly, myad360 expressly
                disclaims any responsibility for the content, the accuracy of the
                information, the quality of products or services provided by or
                advertised on, and / or software downloaded from these third-party
                web sites. Moreover, these links do not imply an endorsement of
                any third party, web site, or products or services provided by any
                third party, and myad360 takes no responsibility for them.
              </p>
              <h4 className="text-[24px] font-bold text-[#0d0c1b]">Mobile</h4>
              <p className="mt-4">
                The Web Site may include certain features and services that may be
                available via your mobile phone, including, without limitation:
                (a) the ability to upload to the Web Site via your mobile phone
                (Mobile Uploads), (b) the ability to receive and reply to messages
                and to send content and messages using text messaging (Mobile
                Text), and (c) the ability to access the Web Site from your mobile
                phone (Mobile Web) (collectively, the “Mobile Services”). We
                generally do not charge for Mobile Services. Your carrier’s normal
                messaging, data and other rates and fees will, however, still
                apply. Your carrier may prohibit or restrict certain Mobile
                Services and certain Mobile Services may be incompatible with your
                carrier or mobile device. You should check with your carrier to
                find out what plans are available and how much they cost. By using
                the Mobile Services you agree that we may communicate with you
                regarding the Web Site and our partners by SMS/ MMS, text message
                or other electronic means to your mobile
              </p>
              <p className="mt-4">
                device and that certain information about your usage of the Mobile
                Services will be communicated to us.
              </p>
              <p className="mt-4">
                You agree that in connection with the Mobile Services for which
                you are registered for, we may send communications to your mobile
                device regarding us or other parties. Further, we may collect
                information related to your use of the Mobile Services. If you
                have registered for Mobile Services, you agree to notify us of any
                changes to your mobile number and update your account on the Web
                Site to reflect this change.
              </p>
              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                Disclaimer and Limitation of Liability
              </h4>
              <p className="mt-4 ">
                ALL CONTENT OF THIS WEB SITE, INCLUDING ANY SOFTWARE, IS PROVIDED
                “AS IS” AND WITHOUT WARRANTIES OR REPRESENTATIONS OF ANY KIND,
                EITHER EXPRESSED OR IMPLIED. TO THE FULLEST EXTENT PERMISSIBLE
                UNDER APPLICABLE LAW, WMG, ITS SUBSIDIARIES, AFFILIATES, AND THEIR
                AGENTS AND ALL PREDECESSORS, SUCCESSORS, AND ASSIGNS DISCLAIM ALL
                WARRANTIES AND REPRESENTATIONS, EXPRESSED OR IMPLIED, RELATING TO
                ANY CONTENT AVAILABLE ON THE SITE, INCLUDING BUT NOT LIMITED TO
                ANY WARRANTIES AND REPRESENTATIONS OF NONINFRINGEMENT OF THIRD
                PARTY INTELLECTUAL PROPERTY RIGHTS, TITLE, MERCHANTABILITY,
                FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT, SYSTEM
                INTEGRATION, OR DATA ACCURACY. WMG, ITS SUBSIDIARIES AND
                AFFILIATES DO NOT WARRANT OR REPRESENT THAT ANY CONTENT OF THIS
                WEB SITE (INCLUDING ANY SOFTWARE) OR ANY DATA ON THIS WEB SITE IS
                ACCURATE, ERROR-FREE, COMPLETE, OR CURRENT, THAT USE OF SUCH
                CONTENT OR DATA WILL BE UNINTERRUPTED, THAT DEFECTS WILL BE
                CORRECTED, OR THAT THIS WEB SITE, ITS CONTENT OR DATA, AND THE
                SERVERS ON WHICH THE WEB SITE AND CONTENT ARE AVAILABLE, ARE FREE
                OF VIRUSES OR OTHER HARMFUL COMPONENTS. MOREOVER, WMG AND ITS
                SUBSIDIARIES AND AFFILIATES DISCLAIM ANY OBLIGATION TO MAINTAIN
                THIS WEB SITE OR KEEP IT OPERATIONAL. APPLICABLE LAW MAY NOT ALLOW
                THE EXCLUSION OF CERTAIN WARRANTIES, SO THESE EXCLUSIONS MAY NOT
                APPLY TO YOU IN WHOLE OR IN PART. YOU ASSUME THE SOLE RISK OF
                MAKING USE OF THIS WEB SITE AND THE CONTENT IT PROVIDES.
              </p>
              <p className="mt-4">
                ALL SERVICES ARE PROVIDED FOR INFORMATIONAL PURPOSES ONLY, AND ARE
                NOT INTENDED FOR TRADING OR INVESTING
              </p>
              <p className="mt-4">
                PURPOSES, OR FOR COMMERCIAL USE. STOCK AND MUTUAL FUND QUOTES, AND
                RELATED FINANCIAL NEWS STORIES MAY BE DELAYED AT LEAST 20 MINUTES,
                AS MAY BE REQUIRED BY THE STOCK EXCHANGES AND/OR THE FINANCIAL
                INFORMATION SERVICES. THE SITE SHOULD NOT BE USED IN ANY HIGH RISK
                ACTIVITIES WHERE DAMAGE OR INJURY TO PERSONS, PROPERTY,
                ENVIRONMENT, FINANCES OR BUSINESS MAY RESULT IF AN ERROR OCCURS.
                YOU EXPRESSLY ASSUME ALL RISK FOR SUCH USE.
              </p>
              <p className="mt-4">
                IN NO EVENT, INCLUDING, BUT NOT LIMITED TO, NEGLIGENCE, SHALL WMG,
                ITS SUBSIDIARIES OR AFFILIATES, INCLUDING ALL PREDECESSORS,
                SUCCESSORS, AND ASSIGNS BE LIABLE FOR ANY INDIRECT, INCIDENTAL,
                PUNITIVE, SPECIAL OR CONSEQUENTIAL DAMAGES INCLUDING, WITHOUT
                LIMITATION, DAMAGES RELATED TO UNAUTHORIZED ACCESS TO OR
                ALTERATION OF YOUR TRANSMISSIONS OR DATA, THE CONTENT OR ANY
                ERRORS OR OMISSIONS IN THE CONTENT, EVEN IF ADVISED OF THE
                POSSIBILITY OF SUCH DAMAGES OR THOSE THAT RESULT FROM THE USE OF,
                OR THE INABILITY TO USE, ANY MATERIALS, PRODUCTS OR SERVICES, OR
                THIRD PARTY MATERIALS, PRODUCTS OR SERVICES MADE AVAILABLE THROUGH
                THE WEB SITE. YOU SPECIFICALLY ACKNOWLEDGE AND AGREE THAT WMG AND
                ITS SUBSIDIARIES AND AFFILIATES ARE NOT LIABLE FOR ANY DEFAMATORY,
                OFFENSIVE OR ILLEGAL CONDUCT OF ANY USER.
              </p>
              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                Use of Company Directories
              </h4>
              <p className="mt-4">
                The information contained in the Company Directories is provided
                for business lookup purposes and is not to be used for marketing
                or telemarketing applications. This information may not be copied
                or redistributed and is provided “AS IS” without warranty of any
                kind. In no event will WMG or its suppliers be liable in any way
                with regard to such Information.
              </p>
              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                Choice of law and Venue
              </h4>
              <p className="mt-4">
                The <Link className="text-green-400"> Privacy Policy.</Link> and
                Terms of Use and the relationship between you and myad360 shall be
                governed by the laws of Brazil without regard to its conflict of
                law provisions. You and myad360 agree to submit to the personal
                and exclusive jurisdiction of the courts located within County of
                Brazil.
              </p>
              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                Termination
              </h4>
              <p className="mt-4">
                myad360 reserves the right in its sole discretion to terminate or
                restrict your use of the Web Site, or any part of the Web Site,
                without notice, for any or no reason, and without liability to you
                or any third party. The Terms of Use relating to Intellectual
                Property Rights, Disclaimer and Limitation of Liability, and
                Choice of Law and Venue shall survive termination.
              </p>
              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                Miscellaneous
              </h4>
              <p className="mt-4">
                This agreement constitutes the entire agreement between myad360
                and you with respect to the subject matter contained in this
                agreement and supersedes all previous and contemporaneous
                agreements, proposals and communications, written and oral. You
                also may be subject to additional terms and conditions that may
                apply when you use specific services on this Web Site, or the
                products or services of a third party that are provided through
                this Web Site.
              </p>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default TermsCondition;
